/* eslint-disable */
import axios from 'axios'
import { AUTH_ENABLED, SIMBA_SERVICE_BASE_URL, AUTH_URL } from './main'
import Vue from 'vue'

const CLIENT_ID = 'JIkkOBJ2YoLOqe2DXufmnfoKyJRUY6h2'

export function getAccessToken() {
  return localStorage.getItem('access_token')
}

function redirectToAuthorize() {
  // check in localStorage or vuex store later on
  const state = 'test' //crypto.randomBytes(8).toString('hex')
  window.location.href = `${AUTH_URL}/authorize/verified-by-gs1-free/?response_type=code&client_id=${CLIENT_ID}&state=${state}&redirect_url=${encodeURIComponent(
    SIMBA_SERVICE_BASE_URL
  )}`
}

export function logout() {
  const params = new URLSearchParams()
  params.append('token', localStorage.getItem('access_token'))
  axios
    .post(
      SIMBA_SERVICE_BASE_URL + '/api/token_service/oauth/token/revoke',
      params,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        }
      }
    )
    .finally(() => {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      window.location.href = `${AUTH_URL}/?logintype=logout`
    })
}

async function callTokenEndpoint(body, redirectOnFail) {
  await axios
    .post(SIMBA_SERVICE_BASE_URL + '/api/token_service/oauth/token', body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      }
    })
    .then(res => {
      const data =
        typeof res.data === 'string' ? JSON.stringify(res.data) : res.data
      const access_token = data.access_token
      const refresh_token = data.refresh_token
      localStorage.setItem('access_token', access_token)
      localStorage.setItem('refresh_token', refresh_token)
    })
    .catch(error => {
      if (error.response.status == 401 && redirectOnFail) redirectToAuthorize()
      else console.log('Authorization error on token endpoint!', error.response)
    })
}

export async function refresh() {
  if (!AUTH_ENABLED) {
    return
  }

  const refresh_token = localStorage.getItem('refresh_token')
  if (!refresh_token) redirectToAuthorize()
  else {
    const params = new URLSearchParams()
    params.append('refresh_token', refresh_token)
    params.append('grant_type', 'refresh_token')
    params.append('client_id', 'JIkkOBJ2YoLOqe2DXufmnfoKyJRUY6h2')
    await callTokenEndpoint(params, true)
  }
}

export async function authenticate(code) {
  if (!AUTH_ENABLED) {
    return true
  }

  if (code) {
    const params = new URLSearchParams()
    params.append('code', code)
    params.append('grant_type', 'authorization_code')
    params.append('client_id', 'JIkkOBJ2YoLOqe2DXufmnfoKyJRUY6h2')
    await callTokenEndpoint(params, false)
    return true
  } else {
    const access_token = localStorage.getItem('access_token')
    const refresh_token = localStorage.getItem('refresh_token')
    if (!access_token && !refresh_token) {
      redirectToAuthorize()
      return false
    }
    if (!access_token && refresh_token) {
      await refresh()
      return true
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/auth.js